import { useSelector } from "react-redux";

import { FreshpaintState } from "@/reducers";

export default function useCurrentEnvironment() {
  return useSelector((state: FreshpaintState) => {
    if (!state.environments.loaded) return null;
    return state.environments.currentEnvironment;
  });
}
